import { render } from "./MaxIcon.vue?vue&type=template&id=455c8cec&scoped=true"
const script = {}

import "./MaxIcon.vue?vue&type=style&index=0&id=455c8cec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455c8cec"]])

export default __exports__